import React, { useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from '../../../components/CKEditor/build/ckeditor';
import { useNewCampaign } from '../../../contexts/NewCampaignContext';

import './editor.css';

const TextEditor = () => {
  const { editorRef, activeInputRef, setTemplateData, templateData } = useNewCampaign();

  const onReadyEditor = (editor) => {
    editorRef.current = editor;
    editor.editing.view.document.on('focus', () => {
      activeInputRef.current = editor;
    });

    // Set the initial content of the editor only once
    if (!editorRef.current.hasBeenSet) {
      editor.setData(templateData.emailTemplate);
      editorRef.current.hasBeenSet = true;
    }
  };

  const onChangeEditor = (event, editor) => {
    const data = editor.getData();
    setTemplateData('emailTemplate', data);
  };

  return (
    <div style={{ marginTop: '1.5rem' }}>
      <CKEditor
        editor={Editor}
        onReady={onReadyEditor}
        onChange={onChangeEditor}
        config={{
          height: '300px',
          
        }}
      />
    </div>
  );
};

export default TextEditor;
